import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { environment } from '../../../environments/environment';
import { setStorageObject } from '../../../utils/storage-manager';
import { AuthService } from './auth.service';

/**
 * Whether the current user can access to a view or not
 */
export const authGuard: CanActivateFn = (_route, { url }) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const isUserLogged = authService.loggedIn();

  if (!isUserLogged) {
    const urlParams = new URLSearchParams(window.location.search);
    const lang = urlParams.get('lang') || '';
    const dotiaUrl = urlParams.get('dotia_url') || '';

    authService.redirectUrl = url;
    const redirectUrlBase = authService.isValidHubDomain() && router.url !== '/hub' ? '/hub' : '/login';
    let redirectUrl = redirectUrlBase === '/login' && lang ? `${redirectUrlBase}?lang=${lang}` : redirectUrlBase;

    if (redirectUrlBase === '/login' && dotiaUrl) {
      const separator = redirectUrl.includes('?') ? '&' : '?';
      redirectUrl += `${separator}dotia_url=${dotiaUrl}`;
    }

    if (redirectUrlBase === '/login' && url && url !== '/login') {
      setStorageObject(environment.pendingRedirectUrlStorage, url);
    }

    return router.parseUrl(redirectUrl);
  }

  return isUserLogged;
};
